import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { AuthProvider } from './context/AuthContext';
import { NativeGestures } from './components/ui/NativeGestures';
import { ToastHost } from './components/ui/Toast';
import { GetTheAppBanner } from './components/ui/GetTheAppBanner';
import { ForceUpdateGate } from './components/ForceUpdateGate';
import { queryClient, persistOptions } from './lib/queryClient';
import { markAppReady } from './lib/ota';
import App from './App';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
      <AuthProvider>
        <BrowserRouter>
          <NativeGestures>
            <App />
          </NativeGestures>
          <ToastHost />
          {/* iOS-browser visitors get a dismissable "Get the app" smart banner
              across the whole app (landing, sign-up, log-in, in-app). No-op in
              the native app, on Android/desktop, or as an installed PWA. */}
          <GetTheAppBanner />
          {/* Sits above the whole app: forces an App Store update when the
              remote config marks this install as too old. No-op on web. */}
          <ForceUpdateGate />
        </BrowserRouter>
      </AuthProvider>
    </PersistQueryClientProvider>
  </StrictMode>
);

// Confirm to the OTA updater that this bundle's JS loaded and executed. Reaching
// this line means every module imported and evaluated without throwing — the
// signal the plugin needs to avoid auto-rolling-back a healthy bundle. Native-only
// inside; harmless no-op on the web. (See web/src/lib/ota.)
void markAppReady();
